document.addEventListener('DOMContentLoaded', () => {
	const navButton = document.querySelector('.nav-button');
	const closeButton = document.querySelector('.close-menu');
	const navContainer = document.querySelector('.mobile-nav-container');

	const body = document.body;

	function openMenu() {
		navContainer.classList.add('is-open');
		navButton.setAttribute('aria-expanded', 'true');
		body.classList.add('no-scroll');
	}

	function closeMenu() {
		navContainer.classList.remove('is-open');
		const isSubMenuOpen = document.querySelector('.c-nav__item--is-open');
		if (isSubMenuOpen) isSubMenuOpen.classList.remove('c-nav__item--is-open');
		navButton.setAttribute('aria-expanded', 'false');
		body.classList.remove('no-scroll');
	}

	if (navButton && navContainer) {
		navButton.addEventListener('click', (e) => {
			e.preventDefault();
			openMenu();
		});
	}

	if (closeButton) {
		closeButton.addEventListener('click', (e) => {
			e.preventDefault();
			closeMenu();
		});
	}

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && navContainer && navContainer.classList.contains('is-open')) {
			closeMenu();
		}
	});

	const menuItems = document.querySelectorAll('.c-nav__item--has-children');

	menuItems.forEach(item => {
		const toggleBtn = item.querySelector('.c-nav__toggle');
		const panel = item.querySelector('.c-nav__panel');
		const titleEl = item.querySelector('.c-nav__link');

		if (!toggleBtn || !panel) return;

		const parentLinkText = titleEl ? titleEl.textContent.trim() : 'Menu';
		const headerHTML = `
            <div class="c-nav__header">
                <button class="c-nav__back-btn">
                    <i class="icon-arrow_left" aria-hidden="true"></i> ${parentLinkText}
                </button>
            </div>
        `;
		panel.insertAdjacentHTML('afterbegin', headerHTML);

		const backBtn = panel.querySelector('.c-nav__back-btn');
		if (backBtn) {
			backBtn.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				item.classList.remove('c-nav__item--is-open');
			});
		}

		toggleBtn.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			item.classList.add('c-nav__item--is-open');
		});
	});

	const regionTrigger = document.getElementById('region-trigger');
	const langPopup = document.getElementById('lang-popup');
	const closeDialogBtn = document.querySelector('.close-dialog');

	if (regionTrigger && langPopup) {
		regionTrigger.addEventListener('click', () => {
			if (typeof langPopup.showModal === "function") {
				langPopup.showModal();
			} else {

				langPopup.style.display = 'block';
			}
		});

		langPopup.addEventListener('click', (e) => {
			const rect = langPopup.getBoundingClientRect();
			const isInDialog = (rect.top <= e.clientY && e.clientY <= rect.top + rect.height
				&& rect.left <= e.clientX && e.clientX <= rect.left + rect.width);

			if (!isInDialog) {
				langPopup.close();
			}
		});

		if(closeDialogBtn) {
			closeDialogBtn.addEventListener('click', () => {
				langPopup.close()
			})
		}
	}
	const langSelect = document.getElementById('lang-select');
	const langContinueBtn = document.getElementById('lang-continue');
	if (langSelect && langContinueBtn) {
		langContinueBtn.addEventListener('click', () => {
			window.location.href = langSelect.value;
		});
	}

});
